module.exports = __webpack_public_path__ + "img/symbol_5.6b7f3544.png";